/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_RemoteInputs */

const en_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote work`)
};

const de_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Homeoffice`)
};

const fr_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télétravail`)
};

const es_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teletrabajo`)
};

const it_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro da remoto`)
};

const nl_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuiswerken`)
};

const pl_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca zdalna`)
};

const fi_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etätyö`)
};

const da_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjernarbejde`)
};

const sv_salary_negotiate_other_remote = /** @type {(inputs: Salary_Negotiate_Other_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distansarbete`)
};

/**
* | output |
* | --- |
* | "Remote work" |
*
* @param {Salary_Negotiate_Other_RemoteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_remote = /** @type {((inputs?: Salary_Negotiate_Other_RemoteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_RemoteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_remote(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_remote(inputs)
	if (locale === "es") return es_salary_negotiate_other_remote(inputs)
	if (locale === "it") return it_salary_negotiate_other_remote(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_remote(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_remote(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_remote(inputs)
	if (locale === "da") return da_salary_negotiate_other_remote(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_remote(inputs)
	return en_salary_negotiate_other_remote(inputs)
});